import moment from 'moment';
// Services
import { getTranslateDocSpecialties } from 'src/views/practitioner/services/appointments';
import { dateWithTimezone } from 'src/services/date';

// Styles & Images
import Calendar from 'assets/images/appointment/calendar.svg';
import DefaultPractitioner from 'assets/images/default-practitioner.svg';
import DefaultProfileSm from 'assets/images/default-profile-sm.svg';
import TimeSuccess from 'assets/images/appointment/time-success.svg';
import * as styles from './styles';


const InfoHeader = (props) => {
  const { campus, date, activeAppointment, patient, practitioner, appointment, i18n } = props;
  const locPractitioner = practitioner && Array.isArray(practitioner.localizations) &&
    practitioner.localizations.find(e => e.lang === i18n.language);

  return (
    <styles.AIH_Header>
      {/* ──── Appointment info ──────────────────────────────────────────────────────────────  */}
      <styles.AIH_Section className="appointment-info">
        <div>
          <img src={Calendar} alt="calendar" />

          <styles.AIH_InfoBlock>
            <span>{date}</span>
            <span>{campus.name}</span>
          </styles.AIH_InfoBlock>
        </div>

        <styles.AIH_TimeBlock>
          <img src={TimeSuccess} alt="time success" />
          <span>{dateWithTimezone(activeAppointment.dateTime)}</span>
        </styles.AIH_TimeBlock>
      </styles.AIH_Section>

      {/* ──── Patient info ────────────────────────────────────────────────────────────────── */}
      <styles.AIH_Section>
        <styles.AIH_ImgWrapper>
          {patient.isUmbi && (
            <styles.AIH_InfoCircleSm
              className={appointment.patient.umbi && appointment.patient.umbi.status}
            />
          )}
          <img src={patient.photo || DefaultProfileSm} alt="patient image" />
        </styles.AIH_ImgWrapper>

        <styles.AIH_InfoBlock>
          <span>{`${patient.firstName} ${patient.lastName}`}</span>
          <span>
            {`${moment(patient.birthDate).format('DD.MM.YYYY')} | ${i18n.t(
              patient.gender ? `gender_${patient.gender.toLowerCase()}` : 'no_data'
            )}`}
            {patient.isNew && <span className="new-user"> | {i18n.t('new')} </span>}
          </span>
        </styles.AIH_InfoBlock>
      </styles.AIH_Section>

      {/* ──── Practitioner info ───────────────────────────────────────────────────────────── */}
      <styles.AIH_Section>
        <styles.AIH_ImgWrapper>
          <img src={practitioner.photo || DefaultPractitioner} alt="practitioner" />
        </styles.AIH_ImgWrapper>

        <styles.AIH_InfoBlock>
          <span>{`${locPractitioner.name}`}</span>
          <span>{getTranslateDocSpecialties(practitioner)}</span>
        </styles.AIH_InfoBlock>
      </styles.AIH_Section>
    </styles.AIH_Header>
  );
};

export default InfoHeader;
